module.exports = __webpack_public_path__ + "static/media/bed.e9594ac1.svg";